(function () {
  function lang() {
    return document.documentElement.getAttribute("data-cn-lang") || "es";
  }
  function t(es, en) {
    return lang() === "en" ? en : es;
  }
  function parseSkuValue(val) {
    var m = String(val || "")
      .trim()
      .match(/^(.*?)[\s_-]+(\d+)\s*pcs$/i);
    if (!m) return null;
    return { model: m[1].replace(/\s+/g, " ").trim(), pack: m[2] };
  }

  function hideDummyOptions() {
    document.querySelectorAll(".variant-option").forEach(function (el) {
      if (el.classList.contains("variant-option--buttons") && el.querySelectorAll("input[type=radio]").length > 1) {
        return;
      }
      var val = el.querySelector('[data-testid="variant-option-single-value"]');
      var txt = ((val && val.textContent) || "").trim();
      if (/^other$/i.test(txt)) el.style.display = "none";
    });
  }

  function organizeSkuPicker(fieldset) {
    if (fieldset.dataset.cnOrg) return;
    var radios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type=radio]'));
    if (radios.length < 6) return;

    var parsed = radios.map(function (r) {
      return { radio: r, p: parseSkuValue(r.value) };
    });
    var ok = parsed.filter(function (x) {
      return x.p;
    });

    if (ok.length < radios.length * 0.6) {
      fieldset.classList.add("cn-var-compact");
      var legend = fieldset.querySelector("legend");
      if (legend && /color/i.test(legend.textContent || "")) {
        legend.textContent = t("Opción", "Option");
      }
      fieldset.dataset.cnOrg = "compact";
      return;
    }

    fieldset.dataset.cnOrg = "model-pack";
    fieldset.classList.add("cn-var-split");
    var models = [];
    var seen = {};
    ok.forEach(function (x) {
      if (!seen[x.p.model]) {
        seen[x.p.model] = 1;
        models.push(x.p.model);
      }
    });
    var packs = [];
    var seenP = {};
    ok.forEach(function (x) {
      if (!seenP[x.p.pack]) {
        seenP[x.p.pack] = 1;
        packs.push(x.p.pack);
      }
    });
    packs.sort(function (a, b) {
      return Number(a) - Number(b);
    });
    var map = {};
    ok.forEach(function (x) {
      map[x.p.model + "|" + x.p.pack] = x.radio;
    });

    var ui = document.createElement("div");
    ui.className = "cn-var-ui";
    var labM = document.createElement("p");
    labM.className = "cn-var-label";
    labM.textContent = t("Modelo", "Model");
    var rowM = document.createElement("div");
    rowM.className = "cn-var-row";
    var labP = document.createElement("p");
    labP.className = "cn-var-label";
    labP.textContent = t("Pack", "Pack");
    var rowP = document.createElement("div");
    rowP.className = "cn-var-row";

    var checked = radios.filter(function (r) {
      return r.checked;
    })[0];
    var cp = checked && parseSkuValue(checked.value);
    var curModel = (cp && cp.model) || models[0];
    var curPack = (cp && cp.pack) || packs[0];

    function apply() {
      var r = map[curModel + "|" + curPack];
      if (!r) {
        for (var i = 0; i < packs.length; i++) {
          if (map[curModel + "|" + packs[i]]) {
            curPack = packs[i];
            r = map[curModel + "|" + packs[i]];
            break;
          }
        }
      }
      if (r && !r.checked) r.click();
      rowM.querySelectorAll("button").forEach(function (b) {
        b.classList.toggle("is-on", b.getAttribute("data-model") === curModel);
      });
      rowP.querySelectorAll("button").forEach(function (b) {
        var pack = b.getAttribute("data-pack");
        var has = !!map[curModel + "|" + pack];
        b.disabled = !has;
        b.classList.toggle("is-on", pack === curPack && has);
      });
    }

    models.forEach(function (m) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cn-var-btn";
      b.setAttribute("data-model", m);
      b.textContent = m.replace(/^Tl-?/i, "TL-");
      b.addEventListener("click", function () {
        curModel = m;
        apply();
      });
      rowM.appendChild(b);
    });
    packs.forEach(function (pack) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cn-var-btn";
      b.setAttribute("data-pack", pack);
      b.textContent = pack === "1" ? t("1 pieza", "1 pc") : pack + " " + t("piezas", "pcs");
      b.addEventListener("click", function () {
        curPack = pack;
        apply();
      });
      rowP.appendChild(b);
    });

    ui.appendChild(labM);
    ui.appendChild(rowM);
    ui.appendChild(labP);
    ui.appendChild(rowP);

    fieldset.querySelectorAll(".variant-option__button-label").forEach(function (l) {
      l.style.display = "none";
    });
    var legend = fieldset.querySelector("legend");
    if (legend) legend.style.display = "none";
    fieldset.insertBefore(ui, fieldset.firstChild);
    apply();
  }

  function money(cents) {
    var n = Number(cents) / 100;
    if (!isFinite(n)) return "";
    return "$" + n.toFixed(2) + " USD";
  }

  function paintPrice(v) {
    if (!v) return;
    var formatted = money(v.price);
    if (!formatted) return;
    document.querySelectorAll(".price").forEach(function (el) {
      if (el.closest(".cart-drawer, .cart-items, .product-card, .product-grid, .predictive-search")) return;
      el.textContent = formatted;
    });
    var compare = v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price) : "";
    document.querySelectorAll(".compare-at-price, s.price, .price--compare").forEach(function (el) {
      if (el.closest(".cart-drawer, .product-card, .product-grid")) return;
      if (compare) {
        el.textContent = compare;
        el.style.display = "";
      }
    });
  }

  function bindPrice() {
    if (!/\/products\//.test(location.pathname)) return;
    var handle = location.pathname.split("/products/")[1] || "";
    handle = handle.split("?")[0].replace(/\/$/, "");
    if (!handle) return;
    fetch("/products/" + handle + ".js")
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var byId = {};
        (data.variants || []).forEach(function (v) {
          byId[String(v.id)] = v;
        });
        function fromRadio(radio) {
          if (!radio) return;
          var id = radio.getAttribute("data-variant-id");
          if (id && byId[id]) paintPrice(byId[id]);
        }
        document.addEventListener(
          "change",
          function (e) {
            var target = e.target;
            if (!target || target.type !== "radio") return;
            fromRadio(target);
          },
          true
        );
        document.addEventListener("click", function (e) {
          var btn = e.target && e.target.closest && e.target.closest(".cn-var-btn");
          if (!btn) return;
          setTimeout(function () {
            fromRadio(document.querySelector(".variant-option input[type=radio]:checked"));
          }, 30);
        });
        fromRadio(document.querySelector(".variant-option input[type=radio]:checked"));
      })
      .catch(function () {});
  }

  function runLight() {
    hideDummyOptions();
    document.querySelectorAll(".variant-option--buttons").forEach(organizeSkuPicker);
  }

  function run() {
    runLight();
    bindPrice();
    var timer;
    var root = document.querySelector("main") || document.body;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var t = m.target;
        if (t && t.closest && t.closest(".cn-var-ui")) continue;
        if (t && t.closest && t.closest(".variant-option, variant-picker, .variant-picker")) {
          clearTimeout(timer);
          timer = setTimeout(runLight, 80);
          return;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains("cn-var-ui")) continue;
          if (
            (n.matches && n.matches(".variant-option, variant-picker, .variant-picker")) ||
            (n.querySelector && n.querySelector(".variant-option--buttons"))
          ) {
            clearTimeout(timer);
            timer = setTimeout(runLight, 80);
            return;
          }
        }
      }
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
